export const LS_MAP_FILTERS_OPEN = 'LS_MAP_FILTERS_OPEN';
export const LS_COMPANY_RATINGS = 'LS_COMPANY_RATINGS';
export const LS_ADDRESS = 'LS_ADDRESS';
export const LS_ZOOM = 'LS_ZOOM';
